(function () {
  function init() {
    var collection = document.querySelector('.collection');
    var facets = document.querySelector('.facets');
    var form = document.getElementById('FacetForm');
    if (!collection || !facets || !form) return;
    if (facets.dataset.hhDrawer === '1') return;
    facets.dataset.hhDrawer = '1';

    // Toggle button, inserted just above the collection grid
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'filters-toggle';
    toggle.id = 'FiltersToggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>' +
      '<span>Filter &amp; Sort</span>' +
      '<span class="filters-toggle__count" id="FiltersToggleCount">0</span>';
    collection.parentNode.insertBefore(toggle, collection);

    // Dimming overlay
    var overlay = document.createElement('div');
    overlay.className = 'facets-overlay';
    document.body.appendChild(overlay);

    // Drawer header
    var header = document.createElement('div');
    header.className = 'facets__header';
    header.innerHTML = '<h3>Filters</h3><button type="button" class="facets__close" aria-label="Close filters">&times;</button>';
    facets.insertBefore(header, facets.firstChild);

    // Wrap the form's existing controls in a scrollable body
    var body = document.createElement('div');
    body.className = 'facets__body';
    while (form.firstChild) body.appendChild(form.firstChild);
    form.appendChild(body);

    // Pull the existing Apply button and Clear link into a sticky footer.
    // NOTE (2026-09-14): this relocation happens at EVERY viewport width, but
    // .facets__footer used to be display:none above 899px — so on tablet-landscape and
    // desktop the sidebar silently lost its "Clear all filters" link and its price
    // Apply button. hh-fixes.css now shows the footer inline at >=900px instead.
    var footer = document.createElement('div');
    footer.className = 'facets__footer';
    var clearLink = body.querySelector('.facet-clear, [data-facet-clear]');
    var applyBtn = body.querySelector('button[type="submit"]');
    if (clearLink) {
      clearLink.classList.add('btn', 'btn--outline');
      clearLink.textContent = 'Clear all';
      footer.appendChild(clearLink);
    }
    if (applyBtn) {
      applyBtn.className = 'btn btn--primary';
      applyBtn.removeAttribute('style');
      applyBtn.textContent = 'Apply filters';
      footer.appendChild(applyBtn);
    }
    form.appendChild(footer);

    function isMobile() {
      return window.matchMedia('(max-width: 899px)').matches;
    }
    function open() {
      facets.classList.add('is-open');
      overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hh-scroll-locked');
    }
    function close() {
      facets.classList.remove('is-open');
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hh-scroll-locked');
    }

    toggle.addEventListener('click', open);
    header.querySelector('.facets__close').addEventListener('click', close);
    overlay.addEventListener('click', close);
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    if (applyBtn) applyBtn.addEventListener('click', function () { if (isMobile()) setTimeout(close, 60); });
    if (clearLink) clearLink.addEventListener('click', function () { if (isMobile()) setTimeout(close, 60); });

    // Active-filter badge, read straight from the URL
    function refreshCount() {
      var el = document.getElementById('FiltersToggleCount');
      if (!el) return;
      var sp = new URLSearchParams(window.location.search);
      var n = sp.getAll('vendors').filter(Boolean).length;
      if (sp.get('avail')) n++;
      if (sp.get('price_min')) n++;
      if (sp.get('price_max')) n++;
      el.textContent = String(n);
      el.classList.toggle('is-visible', n > 0);
    }
    refreshCount();
    window.addEventListener('popstate', refreshCount);
    // FIX (2026-09-14): the collection script navigates with history.pushState, which
    // does NOT fire popstate — so the badge was only ever correct on first load and on
    // back/forward. Applying or clearing a filter left a stale count. main-collection
    // now dispatches this event after every navigate().
    window.addEventListener('hh:facets-changed', refreshCount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();